import { jsx, Fragment } from 'react/jsx-runtime';
import { styled, Typography } from '@mui/material';

function Description({ children, disableTypography, divider = false, typographyProps = {}, sx = {}, }) {
    return (jsx(Wrapper, { "$divider": divider, className: "card-form-description", sx: sx, children: disableTypography ? (jsx(Fragment, { children: children })) : (jsx(Typography, Object.assign({ variant: "small" }, typographyProps, { children: children }))) }));
}
const Wrapper = styled("div")(({ theme, $divider }) => (Object.assign({ width: "100%", margin: theme.spacing(-1, 0, 1), color: theme.palette.text.high, gridColumn: "span 12" }, ($divider && {
    borderBottom: `1px solid ${theme.palette.ui50}`,
}))));

export { Description };
//# sourceMappingURL=Description.js.map
